export default function incluirPlanodeconta(planosdecontas, planodeconta) {
  if (planosdecontas.some(item => item.id === planodeconta.id)) {
    return planosdecontas;
  }

  return [...planosdecontas, planodeconta];
}
